var React = require('react');

function SocialWantedly (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M1.5 7H5.54082L11.602 20.5L13.6224 16L9.58163 7H13.6224L15.6429 11.5L17.6633 7H21.7041L17.6633 16L19.6837 20.5L25.7449 7H29.7857L21.7041 25H17.6633L15.6429 20.5L13.6224 25H9.58163L1.5 7Z","fill":"#222222"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"29","height":"18","fill":"white","transform":"translate(1.5 7)"})))]);
}

SocialWantedly.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = SocialWantedly;

SocialWantedly.default = SocialWantedly;
